"use client";
import { useState, useEffect, useRef } from "react";
import { BuyOrAddToCarWrapper, CounterBoxWrapper } from "@/styles/product";
import Counter from "../../components/counter/index";
import UKToast from "@/components/UKToast";
import { getUserUUIDFromCookie } from "@/utils/userUtils";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { styled as muiStyled } from "@mui/material/styles";
import { AddCart } from "@/apis/service";
import { callAfterLogin } from "@/lib/jdiClientUtils";
import { getGift } from "@/common-components-src/js/main";
import type { CartParams } from "@/apis/service";
import { MESSAGE } from "@/utils/const";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";
import { useTranslation } from "@/i18n/client";
const buttonCommonStyle = {
  fontSize: "16px",
  width: "228px",
  height: "48px",
  borderRadius: "4px",
  lineHeight: "48px",
  textAlign: "center",
  fontWeight: 700,
};
const AddCartButton = muiStyled(Button)(({ theme }) => ({
  ...buttonCommonStyle,
  border: "1.5px solid #505259",
  backgroundColor: "#FFFFFF",
  color: "#1A1A1A",
  "&:hover": {
    color: "#990915",
    borderColor: "#990915",
    backgroundColor: "#FFFFFF",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
    cursor: "no-drop",
    color: "#C2C4CC",
    borderColor: "#C2C4CC",
    backgroundColor: "transparent",
  },
}));

const BuyNowButton = muiStyled(Button)(({ theme }) => ({
  ...buttonCommonStyle,
  color: "#fff",
  backgroundColor: "#CC0C1C",
  "&:hover": {
    borderColor: "#990915",
    backgroundColor: "#990915",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
    cursor: "no-drop",
    color: "#fff",
    borderColor: "#FF9FA7",
    backgroundColor: "#FF9FA7",
  },
}));
export default function BuyOrAddToCar(props: any) {
  const floors = props.floors;
  const { t } = useTranslation();
  const { productCommonFloor, productBottomBarFloor } = floors;
  const data = productCommonFloor?.data;
  const Basic_data = data?.["C-M#viewCommonItem&commonBasic"];

  const producet_data = data?.["C-M#viewCommonItem&commonCore"];

  const isBuyProduct = productBottomBarFloor?.data?.unsupportedPurchaseInfo?.type || 1;
  const [productNumber, setproductNumber] = useState<number>(1);
  const [floatHeight, setFloatHeight] = useState<number>();
  const stockValue = Basic_data?.maximumPurchaseLimit || 200;

  const cartuuidRef = useRef<string>("");
  const buyRef = useRef<string>();

  const addCart = async (props: Record<CartParams> = {}) => {
    const params = {
      cartuuid: cartuuidRef.current,
      num: productNumber,
      skuId: producet_data.skuId,
    };
    const data = await AddCart(params);
    if (data?.code === "200") {
      UKToast.show({
        content: "Added to Cart!", // 弹窗内容
        icon: "success", // 可选：success, fail, loading, warn, info，影响图标
      });
      (window as any).JDIheader.initCartNum();
    } else {
      UKToast.show({
        content: "Added to cart Failed please try again", // 弹窗内容
        icon: "error", // 可选：success, fail, loading, warn, info，影响图标
      });
    }
    sendClickTrack.Productdetail_Addtocart({
      mainskuid: producet_data.skuId,
      skuNum: String(productNumber),
    });
  };
  // 打开结算页
  const openCheckout = async () => {
    const skuId = producet_data.skuId;
    callAfterLogin(
      async () => {
        getGift().then(() => {});
        try {
          sendClickTrack.Productdetail_GotoBuyNow({
            mainskuid: producet_data.skuId,
            skuNum: String(productNumber),
          });
        } catch (err) {}

        const params = {
          cartuuid: cartuuidRef.current,
          num: productNumber,
          skuId,
        };
        const data = await AddCart({ refer: 7, ...params });
        if (data?.code === "200") {
          let url =
            process.env.NODE_ENV === "development"
              ? `${process.env.NEXT_PUBLIC_FE_TEST_DOMAIN}/checkout?ref=${skuId}&immediatelyBuy=true`
              : `/checkout?ref=${skuId}&immediatelyBuy=true`;
          window.location.href = url;
        } else {
          UKToast.show({
            content: MESSAGE.SERVER_ERROR,
            icon: "error",
          });
        }
      },
      {
        isRefresh: false,
      },
    );
  };
  const handleChangeNum = (item: any, num: number) => {
    if (!item) {
      return;
    }
    setproductNumber(num);
  };

  useEffect(() => {
    cartuuidRef.current = getUserUUIDFromCookie();
  }, []);

  return (
    <>
      <CounterBoxWrapper>
        {/* 商品数量 */}
        <span className="counnter-title">{t("dp.qty")}</span>
        <Counter
          immediately={false}
          value={productNumber}
          minAmount={Basic_data?.minimumPurchaseLimit ? Number(Basic_data.minimumPurchaseLimit) : 1}
          maxAmount={Basic_data?.maximumPurchaseLimit ? Number(Basic_data.maximumPurchaseLimit) : 200}
          stock={stockValue}
          onChange={(num) => {
            if (num >= 1) {
              handleChangeNum(data, num);
            }
          }}
        />
      </CounterBoxWrapper>
      <BuyOrAddToCarWrapper ref={buyRef}>
        {/* 无购物车 */}
        <div className="inner sticky">
          <Stack direction="row" spacing="8px">
            <AddCartButton
              size="large"
              disabled={isBuyProduct < 0}
              onClick={() => addCart()}
              exptag={"exp|" + EXPOSURE_RECORD.Productdetail_Addtocart_Expo}
              data-exptag-config={dataExpTagConfig}
            >
              {t("dp.addToCart")}
            </AddCartButton>
            <BuyNowButton
              size="large"
              disabled={isBuyProduct < 0}
              onClick={openCheckout}
              exptag={"exp|" + EXPOSURE_RECORD.Productdetail_GotoBuyNow_Expo}
              data-exptag-config={dataExpTagConfig}
            >
              {t("dp.buyNow")}
            </BuyNowButton>
          </Stack>
        </div>
      </BuyOrAddToCarWrapper>
    </>
  );
}
